import {createAsyncThunk} from '@reduxjs/toolkit'

import {PAYMENT_ROUTES} from '@web/core/routes'
import {changeBrowserLocation} from '@web/helpers/browser'

import {LocationChangeHistoryParam, ThunkApi} from '../interfaces'

/**
 * 결제형 자동 주문서로 이동
 */
const navigateToNaverFinancialAutoCheckout = createAsyncThunk<
    void,
    (LocationChangeHistoryParam & {reservedId: string}) | void,
    ThunkApi
>('navigateTo/naverFinancialAutoCheckout', async (args) => {
    const {historyType = 'PUSH', reservedId} = args ?? {}
    const url = `${PAYMENT_ROUTES.NAVER_FINANCIAL_AUTO.MAIN}/${reservedId}`

    changeBrowserLocation({url, type: historyType})
})

export default navigateToNaverFinancialAutoCheckout
